import React, { useEffect, useRef } from 'react';
const IntersectionTrigger = ({ onBottom, children }) => {
    const subject = useRef(null);
    useEffect(() => {
        const handleObserver = (entries) => {
            const target = entries[0];
            if (target.isIntersecting) {
                onBottom();
            }
        };
        const options = {
            root: null,
            rootMargin: '50px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, options);
        const currentSubject = subject.current;
        if (currentSubject) {
            observer.observe(currentSubject);
        }
        return () => {
            if (currentSubject) {
                observer.unobserve(currentSubject);
            }
        };
    }, [onBottom]);
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement("div", { ref: subject })));
};
export default IntersectionTrigger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZXJzZWN0aW9uVHJpZ2dlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NoYXJlZC9JbnRlcnNlY3Rpb25UcmlnZ2VyL0ludGVyc2VjdGlvblRyaWdnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxFQUFFLEVBQUUsU0FBUyxFQUFFLE1BQU0sRUFBRSxNQUFNLE9BQU8sQ0FBQztBQU1qRCxNQUFNLG1CQUFtQixHQUF3QixDQUFDLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxFQUFFLEVBQUU7SUFDeEUsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFpQixJQUFJLENBQUMsQ0FBQztJQUM3QyxTQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsTUFBTSxjQUFjLEdBQUcsQ0FBQyxPQUFvQyxFQUFFLEVBQUU7WUFDNUQsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQzFCLElBQUksTUFBTSxDQUFDLGNBQWMsRUFBRSxDQUFDO2dCQUN4QixRQUFRLEVBQUUsQ0FBQztZQUNmLENBQUM7UUFDTCxDQUFDLENBQUM7UUFDRixNQUFNLE9BQU8sR0FBRztZQUNaLElBQUksRUFBRSxJQUFJO1lBQ1YsVUFBVSxFQUFFLE1BQU07WUFDbEIsU0FBUyxFQUFFLENBQUM7U0FDZixDQUFDO1FBQ0YsTUFBTSxRQUFRLEdBQUcsSUFBSSxvQkFBb0IsQ0FBQyxjQUFjLEVBQUUsT0FBTyxDQUFDLENBQUM7UUFDbkUsTUFBTSxjQUFjLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQztRQUN2QyxJQUFJLGNBQWMsRUFBRSxDQUFDO1lBQ2pCLFFBQVEsQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLENBQUM7UUFDckMsQ0FBQztRQUNELE9BQU8sR0FBRyxFQUFFO1lBQ1IsSUFBSSxjQUFjLEVBQUUsQ0FBQztnQkFDakIsUUFBUSxDQUFDLFNBQVMsQ0FBQyxjQUFjLENBQUMsQ0FBQztZQUN2QyxDQUFDO1FBQ0wsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQztJQUVmLE9BQU8sQ0FDSDtRQUNLLFFBQVE7UUFDVCw2QkFBSyxHQUFHLEVBQUUsT0FBTyxHQUFJLENBQ3RCLENBQ04sQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVGLGVBQWUsbUJBQW1CLENBQUMifQ==